module.exports = __webpack_public_path__ + "resources/img/img-vcast-cloud-01-m.d2b48ab3e29f0259c3b420f26c4c3519.png";